// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"336c2a81","703":"c6393a7f"}[chunkId] + ".chunk.js";
};